/**
 * Features Section
 */

import Swiper, { Navigation } from "swiper";

export default {
    init() {
        if (document.querySelector('.swiper-features')) {
            Array.from(document.querySelectorAll('.swiper-features'))
                .forEach(el => {
                    el.swiper = new Swiper(el, {
                        modules: [Navigation],
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2.2,
                            },
                            992: {
                                slidesPerView: 3,
                            }
                        }
                    });
                });
        }
    }
}
